import PageProductDetail from '~/themes/base/components/product/PageProductDetail/PageProductDetail.vue'

export default {
  extends: PageProductDetail,
  computed: {
    showOfferDateOfStorage() {
      return this.$themeSettings.components.PageProductDetail.showDateOfStorage
    },
    showOfferAvailability() {
      return this.$themeSettings.components.PageProductDetail.showAvailability
    },
    showOfferDeliveryOptions() {
      return (
        this.$themeSettings.components.PageProductDetail.showDeliveryOptions &&
        this.displayedVariant.availability.isAvailable &&
        this.$store.state.cart.isLoaded &&
        this.product.availability.delayDays < 21
      )
    },
    availableLocalizedFiles() {
      return this.product.files.filter(file => file.locale === this.$i18n.locale)
    },
  },
}
